import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { InitializerService } from '../../../initializer.service';
import { urlApi } from '../../../utils/apiConfig';

interface ObjectInsertFileCsv {
  fileCsv: string;
  idList: number;
}

interface DataObjectManualy {
  idList: number;
  nome: string;
  number: string;
}


@Injectable()
export class ListasService {

  constructor(private http: HttpClient) {
   
   }


  public getListas(): Observable<any> {
    return this.http.get(`${urlApi}/app/list/`);
  }

  public setLista(dataObject: any): Observable<any> {
    return this.http.post(`${urlApi}/app/list/create`, dataObject);
  }

  public deleteLista(idList: number): Observable<any> {
    return this.http.delete(`${urlApi}/app/list/delete/${idList}`);
  }

  public getNumbersInLista(idLista: number): Observable<any>{
    return this.http.get(`${urlApi}/app/contactlist/${idLista}`);
  }

  public deleteNumberInLista(idContact: number): Observable<any>{
    return this.http.delete(`${urlApi}/app/contactlist/delete/${idContact}`)
  }

  public setFileCsvInLista(objectData: ObjectInsertFileCsv): Observable<any>{
    return this.http.post(`${urlApi}/app/list/contacts/create`, objectData);
  }

  public setNumberInFilaManualy(dataObject: DataObjectManualy): Observable<any> {
    return this.http.post(`${urlApi}/app/list/contact/create`,dataObject);
  }

}
